import { MarketingPreferences } from './types'

export const defaultMarketingPreferences: MarketingPreferences = {
  raiseAnnouncements: { isActive: true, label: 'Raise announcements' },
  productUpdates: { isActive: true, label: 'Product updates' },
  weeklyNewsletter: { isActive: true, label: 'Weekly newsletter' },
  vestingUpdates: { isActive: true, label: 'Vesting updates' },
}

export const SIGN_COPY = 'Sign this message to confirm your wallet address:'
